var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDismiss = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  className: "_dm-svg",
  focusable: "false",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.969 10.354a.687.687 0 01-.198.48l-.938.937a.663.663 0 01-.948 0L8 9.885l-1.885 1.886a.663.663 0 01-.948 0l-.938-.938a.663.663 0 010-.948L6.115 8 4.229 6.115a.663.663 0 010-.948l.938-.938a.663.663 0 01.948 0L8 6.115l1.885-1.886a.663.663 0 01.948 0l.938.938a.663.663 0 010 .948L9.885 8l1.886 1.885a.663.663 0 01.198.47zM16 8c0-4.417-3.583-8-8-8S0 3.583 0 8s3.583 8 8 8 8-3.583 8-8z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDismiss);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Dismiss.cfc838a929058be15d852005ee77a8a4.svg";